import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import {
    getRecoilStateValue,
    updateRecoilState,
} from "../../../Orchestrator/Recoils/Events/Recoil";
import {
    IBookingsListPagination,
} from "../../../Orchestrator/Recoils/BookingAtom";
import { BOOKINGS_PAGE_SIZE, processBookingsList } from "./UpcomingPastBookingTabAction";

// Both tabs paginate lazily: the full date-sorted summary list lives in
// `allResults`, and "Load more" builds the details for the next `pageSize`
// summaries and appends them. Appending in pre-sorted order means rows already
// on screen never reshuffle. Guarded by `isLoadingMore` to serialize clicks.
class LoadMoreBookingsAction extends BaseAction<void, void> {
    override async run(): Promise<void> {
        const pagination = getRecoilStateValue<IBookingsListPagination>(
            "bookingsListPaginationAtom"
        );

        if (!pagination || pagination.isLoadingMore || !pagination.activeTab) {
            return;
        }

        const size = pagination.pageSize || BOOKINGS_PAGE_SIZE;
        const allResults = pagination.allResults || [];
        const nextSlice = allResults.slice(pagination.offset, pagination.offset + size);
        if (nextSlice.length === 0) {
            return;
        }

        updateRecoilState<IBookingsListPagination>("bookingsListPaginationAtom", {
            ...pagination,
            isLoadingMore: true,
        });

        try {
            await processBookingsList(
                nextSlice,
                pagination.activeTab,
                !!pagination.lastIsAnonymous,
                { append: true }
            );
            // Safe to spread the `pagination` captured before the await: the
            // `isLoadingMore` guard above serializes clicks and nothing else
            // writes this atom during the build, so it can't be stale.
            updateRecoilState<IBookingsListPagination>("bookingsListPaginationAtom", {
                ...pagination,
                offset: pagination.offset + nextSlice.length,
                isLoadingMore: false,
            });
        } catch (error) {
            updateRecoilState<IBookingsListPagination>("bookingsListPaginationAtom", {
                ...pagination,
                isLoadingMore: false,
            });
            console.error("Load more bookings failed:", error);
        } finally {
            _eventBus.emit({ eventName: "BOOKING_DATA_LOADED" });
        }
    }
}

export const loadMoreBookingsAction = new LoadMoreBookingsAction();
